import { getPlatform } from '../PlatformAccessor';
import { PlatformDependencySet } from './platformDependencies';

export const resolveFromGlobal = <Token extends PlatformDependencySet>(
	token: Token | string
) => getPlatform().globalDependencyResolver(token);
